import React from "react";
import { formatAudAmount } from "../../../utils/audCurrency";

const buildAvatarDataUri = (name = "Teacher") => {
  const safeName = String(name || "Teacher").trim() || "Teacher";
  const initial = safeName.charAt(0).toUpperCase();
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
      <defs>
        <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#f97316" />
          <stop offset="100%" stop-color="#ef4444" />
        </linearGradient>
      </defs>
      <rect width="128" height="128" rx="24" fill="url(#bg)" />
      <text x="50%" y="52%" text-anchor="middle" dominant-baseline="middle" font-family="Arial, sans-serif" font-size="48" font-weight="700" fill="white">
        ${initial}
      </text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

const TutorCard = ({ tutor, onClick, isSelected = false }) => {
  const yearChips = Array.isArray(tutor.years) ? tutor.years.filter(Boolean) : [];
  const isClickable = typeof onClick === "function";
  const avatarFallback = buildAvatarDataUri(tutor?.name);

  return (
    <div
      className={`bg-white rounded-2xl p-6 shadow-md border border-gray-200 transition-all ${
        isClickable ? "cursor-pointer hover:shadow-lg hover:border-[#08A595]" : ""
      } ${
        isSelected ? "ring-2 ring-[#08A595]/30" : ""
      }`}
      onClick={onClick}
    >
      <div className="flex gap-4">
        <img
          src={tutor.image}
          alt={tutor.name}
          className="w-24 h-24 object-cover rounded-xl"
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = avatarFallback;
          }}
        />

        <div className="flex flex-col flex-1">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900">
              {tutor.name}
            </h3>
            <span className="text-gray-500 text-lg">›</span>
          </div>

          <div className="flex items-center gap-2 text-gray-700 text-sm mt-1">
            <span>{tutor.experience}</span>
          </div>

          <p className="text-gray-600 text-sm mt-2">
            {tutor.description}
          </p>

          <div className="flex flex-wrap gap-2 mt-3">
            {yearChips.map((year, i) => (
              <span
                key={i}
                className="px-3 py-1 bg-gray-100 border border-gray-300 rounded-full text-xs"
              >
                {year}
              </span>
            ))}
          </div>

          <p className="mt-3 text-[#08A595] font-semibold">
            {typeof tutor.price === "number"
              ? `${formatAudAmount(tutor.price)}/session`
              : "Price on request"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TutorCard;
